export default __webpack_public_path__ + "static/media/food-global.2b92dcb9.csv";